import { render, staticRenderFns } from "./SelectGender.vue?vue&type=template&id=4c514526"
import script from "./SelectGender.vue?vue&type=script&lang=js"
export * from "./SelectGender.vue?vue&type=script&lang=js"
import style0 from "./SelectGender.vue?vue&type=style&index=0&id=4c514526&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports